// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_94-3";
export var contentContainer = "_94-0";
export var editorContainer = "_94-1";
export var quillInputForm = "_94-2";
export var zoneDivider = "_94-4";